:host {
  display: block;
}
.qumra-option-img-container{
  display: flex;
  gap: 8px;
}
.qumra-option-img-container >div {
   display: flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   border-radius: var(--mainRadius);
   padding: 4px;
   border: 1px solid var(--mainColor);
   color: var(--mainColor);
}
.qumra-option-img-container >div  img{
  width: 40px;
  height: 40px;
  border-radius: var(--mainRadius);
  object-fit: contain;
}